import { useQuery } from "@tanstack/react-query";

import type { Pricing } from "common/types";

import { post } from "../helpers/HTTP";

async function customerEstimateUpdateRequest(
  planId: string,
  quantity: number,
  prorate: boolean,
): Promise<{
  amountDue: number;
  nextBillingAt: number;
  pricePerItem: number;
}> {
  const { estimate } = await post("subscriptions/estimates/update", {
    item_price_id: planId,
    seat_count: quantity,
    prorate,
  });

  const { subscription_estimate: subscriptionEstimate } = estimate;

  const invoiceEstimate =
    estimate.invoice_estimate || estimate.next_invoice_estimate;

  return {
    amountDue: invoiceEstimate.sub_total,
    nextBillingAt: subscriptionEstimate.next_billing_at,
    pricePerItem: invoiceEstimate.line_items.find(
      ({ pricing_model }: { pricing_model: string }) =>
        pricing_model === "per_unit",
    ).unit_amount,
  };
}

export default function useCustomerEstimateUpdate({
  pricing,
  quantity,
  prorate,
}: {
  pricing: { addon: Pricing; plan: Pricing };
  quantity: number;
  prorate: boolean;
}) {
  const { plan } = pricing;

  const { data: estimateUpdate, isLoading: isLoadingEstimateUpdate } = useQuery(
    {
      queryKey: ["customerEstimateUpdate", pricing, quantity, prorate],
      queryFn: () => customerEstimateUpdateRequest(plan.id, quantity, prorate),
    },
  );

  return { estimateUpdate, isLoadingEstimateUpdate };
}
